// extracted by mini-css-extract-plugin
export default {"container":"container-RH90bpmj","inventory":"inventory-Z_fB4M0x","beige":"beige-zaMrS3eq","dark":"dark-rdCevOYr","controlPanel":"controlPanel-QAvgAEaz","title":"title-3UpBGbu9"};